var _line, _path, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterStarLineMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 43,
    viewBox: "0 0 389 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -1.99351,
    y1: 22.1572,
    x2: 290.008,
    y2: 21.3838,
    stroke: "#DCFF79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.687 21.7031C308.602 23.6961 303.821 28.4764 301.828 34.5615C299.835 28.4764 295.055 23.6961 288.97 21.7031C295.055 19.71 299.835 14.9297 301.828 8.8446C303.821 14.9297 308.602 19.71 314.687 21.7031Z",
    stroke: "#DCFF79"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 314.009,
    y1: 21.3838,
    x2: 388.009,
    y2: 21.3838,
    stroke: "#DCFF79"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterStarLineMobile);
export default __webpack_public_path__ + "static/media/FooterStarLineMobile.efcfc52d.svg";
export { ForwardRef as ReactComponent };